<template>
  <el-container class="h-100 w-100 bg-ff">
    <el-main class="flex-column">
      <div class="customerInfo flex align-center justify-space-between">
        <div class="flex align-center">
          <div class="font-18-30313a font-bold">{{ type === 2 ? '客户收款' : type === 1 ? '工程付款' : '客户提成' }}</div>
          <div class="line"></div>
          <div>
            <div><span>客户信息：</span>{{ info.name }}</div>
            <div><span>装修地址：</span>{{ info.detailedAddress }}</div>
          </div>
          <div class="line"></div>
          <div>
            <div><span>设计师：</span>{{ customerAssign.designerName ? customerAssign.designerName : '-' }}</div>
            <div><span>预算员：</span>{{ customerAssign.beName ? customerAssign.beName : '-' }}</div>
          </div>
        </div>
        <div class="close flex align-center justify-center cursor" @click="onClose">
          <i class="el-icon-close font-18-ff"></i>
        </div>
      </div>
      <div class="content flex-column flex-1 bg-f3f4f7">
        <div class="flex mb-10">
          <div class="title flex align-center bg-ff flex-1">
            <div class="flex align-center mr-20 cursor"
              v-for="(item, index) in (type === 2 ? tab : type === 1 ? tab1 : tab2)" :key="index"
              @click="switchTab(index + 1)">
              <div class="mr-5" :class="index + 1 === tabIndex ? 'decoration-line' : 'decoration-line-hui'"></div>
              <div class="font-bold" :class="index + 1 === tabIndex ? 'font-16-46b8b0' : 'font-16-30313a'">{{ item }}
              </div>
            </div>
          </div>
        </div>
        <div v-if="tabIndex === 1">
          <div class="flex"
            v-if="permission.includes('commissionBasic') || permission.includes('customerReceivablesBasic') || permission.includes('projectPaymentBasic')">
            <div class="flex align-center mr-5 mb-5 " :class="addIndex === 0 ? 'btn-24-bg-46b8b0' : 'btn-24-bd-30313a'"
              @mouseenter="enter(0)" @mouseleave="leave(0)" @click="addPaymentOrder">
              <img :src="addIndex === 0 ? '/static/images/add-bai.png' : '/static/images/add.png'" class="icon-14 mr-5"
                alt="">
              <div>{{ type === 2 ? '新增收款单' : type === 1 ? '新增付款单' : '新增提成单' }}</div>
            </div>
          </div>
          <div style="height: 500px">
            <erp-table ref="erpTable" :table-data="paymentDetail" :customs="[{ field: 'operate', visible: visibleShow }]"
              btn-show-key="status" :loading="loading" :column-data="columnData" @on-detail="onDetail"
              @on-delete="onDelete" @on-refund="onRefund" @on-account="onAccount" :table-footer="tableFooter"></erp-table>
          </div>
          <div style="margin-top: 10px;">
            <Pagination :pageSize="pageSize" v-model="pageNo" :pageTotal="pageTotal" :total="total" @on-jump="jump">
            </Pagination>
          </div>
        </div>
        <div v-if="tabIndex === 2">
          <div style="height: 500px">
            <erp-table ref="erpTable" :table-data="statisticalData" btn-show-key="status" :loading="loading"
              :column-data="statistical" @on-detail="onDetail" @on-delete="onDelete" @on-refund="onRefund"
              @on-account="onAccount" :table-footer="tableFooter3"></erp-table>
          </div>
        </div>
      </div>
    </el-main>
    <!--详情-->
    <div class="filtrate">
      <el-dialog :visible.sync="detailDialog" width="85%" :show-close="false">
        <div class="header">
          <div class="font-bold " :class="founddetail.status === 1 ? 'font-22-30313a' : 'font-22-ff5555'">
            {{ founddetail.status === 1 ? '收款单据' : '退款单据' }}</div>
          <i class="el-icon-close close1" @click="detailDialog = false"></i>
        </div>
        <div class="p-absolute" style="top: 0;left: 20px;"><img
            :src="founddetail.status === 1 ? '/static/images/weijizhang.png' : '/static/images/yijizhang.png'"
            style="width: 15px;height: auto" alt=""></div>
        <div class="bg-f3f4f7 flex text-left plr-20 ptb-10 align-center">
          <div class="flex-1 mr-40">
            <div class="font-12-30313a"><span class="font-12-b9b9b9">{{ type === 2 ? '收款' : type === 1 ?
              '付款' : '提成' }}单号：</span>{{ founddetail.number }}</div>
            <div class="font-12-30313a" v-if="founddetail.status == 2"><span class="font-12-b9b9b9">纸质单号：</span>{{
              founddetail.writingNumber }}</div>
            <div class="flex font-12-30313a" v-else><span class="font-12-b9b9b9">纸质单号：</span><el-input placeholder="请输入"
                @change="orderNumber" class="" v-model="founddetail.writingNumber"></el-input></div>
          </div>
          <div class="flex-1 mr-40">
            <div class="font-12-30313a"><span class="font-12-b9b9b9">{{ type === 2 ? '收款' : type === 1 ?
              '付款' : '提成' }}人员：</span>{{ founddetail.accounterName }}</div>
            <div class="font-12-30313a" v-if="founddetail.status == 2"><span class="font-12-b9b9b9">{{ type === 2 ? '收款' :
              type === 1 ? '付款' : '提成' }}账户：</span>{{ founddetail.account }}</div>
            <div class="font-12-30313a flex align-center" v-else><span class="font-12-b9b9b9">{{ type === 2 ? '收款' : type
              === 1 ? '付款' : '提成' }}账户：</span>
              <el-select v-model="founddetail.account" placeholder="请选择" @change="selectAccount">
                <div v-for="(item, index) in optionList" :key="index">
                  <template v-if="item.children">
                    <el-option-group :key="item.id" :label="item.name">
                      <el-option v-for="itemcell in item.children" :key="itemcell.id" :label="itemcell.name"
                        :value="itemcell.id">
                      </el-option>
                    </el-option-group>
                  </template>
                  <template v-else>
                    <div>
                      <el-option :label="item.name" :value="item.id"></el-option>
                    </div>
                  </template>
                </div>
              </el-select>
            </div>
          </div>
          <div class="flex-2">
            <div class="font-12-30313a flex">
              <div class="flex flex-1"><span class="font-12-b9b9b9">客户信息：</span>{{ info.name }} /
                {{ info.telephone }}/{{ info.detailedAddress }}</div>
              <div class="flex flex-1 justify-end align-center" v-if="founddetail.status === 1"><span
                  class="font-12-b9b9b9">开单时间：</span>
                <el-date-picker v-model="founddetail.createTime" type="date" @change="openOrderTime" format="yyyy.MM.dd ">
                </el-date-picker>
              </div>
              <div class="flex flex-1 justify-end" v-else><span class="font-12-b9b9b9">开单时间：</span>{{
                Utils.formatDate(founddetail.createTime) }}</div>
            </div>
            <div class="flex" :class="founddetail.status === 1 ? 'font-12-30313a' : 'font-12-ff5555'"><span
                class="font-12-b9b9b9">单据备注：</span><el-input placeholder="请输入" @change="orderMark" class=""
                v-model="founddetail.description"></el-input></div>
          </div>
        </div>
        <div class="plr-20 ptb-10">
          <div style="height: 250px">
            <erp-table :is-edit="true" ref="erpTable" @on-modify="onModify" modify-method="on-modify"
              :table-data="founddetail.financeBillItemList" :loading="loading" :column-data="columnDetail"
              :table-footer="tableFooter2"></erp-table>
          </div>
        </div>
        <div slot="footer">
          <div class="btn-30-bg-46b8b0 mr-10" @click="toSave">保存</div>
          <div class="btn-30-bg-82b925 mr-10" @click="isReportShow = true">打印</div>
        </div>
      </el-dialog>
    </div>
    <AddDetail ref="addDetail" @submit-bill="onSubmitBill" :type="type" :customerId="id"
      :customerAddress="info.name + '/' + info.detailedAddress"></AddDetail>
    <el-dialog title="打印" :visible.sync="isReportShow" :fullscreen="true" class="flex-column" width="85%">
      <report :classify-id="6" :id="this.founddetail.id" :orderDefineId="type === 2 ? 1 : type === 1 ? 2 : 3"></report>
      <!--1 收 2 付 3提成-->
    </el-dialog>
  </el-container>
</template>

<script>
import ErpTable from '../../../components/ErpTable'
import Pagination from '../../../components/Pagination'
import AddDetail from '../../financeManage/comp/AddDetail'
import Report from '../../../components/Report'

export default {
  name: 'payment',
  components: { ErpTable, Pagination, AddDetail, Report },
  props: ['type'],
  data () {
    return {
      permission: [],
      visibleShow: true,
      info: {},
      id: '',
      customerAssign: {},
      tabIndex: 1,
      tab: ['收款明细清单', '收款统计'],
      tab1: ['付款明细清单', '付款统计'],
      tab2: ['提成明细清单', '提成统计'],
      addIndex: -1,
      addIndex1: -1,
      page: 1,
      limit: 25,
      pageSize: 10, // 总页数
      pageNo: 1, // 当前页数
      pageTotal: 25, // 当前页条数
      total: 100, // 总条数
      detailDialog: false,
      isReportShow: false,
      loading: false,
      ways: {},
      account_id: '',
      account: '',
      writingNumber: '',
      description: '',
      fundList: [{
        field: 'isAccounting',
        title: '记账',
        width: '60',
        editType: 'select',
        editRender: {
          name: 'select', // 编辑框为下拉框
          options: [
            {
              value: 1,
              label: '是'
            },
            {
              value: 0,
              className: 'color-46b8b0',
              label: '否'
            }
          ]
        }
      }, {
        field: 'specialItem',
        title: '代码',
        width: '80'
      }, {
        field: 'formulaCompute',
        title: '计算公式',
        width: '100'
      }, {
        field: 'itemName',
        title: '款项内容',
        width: '166'
      }, {
        field: 'planBill',
        title: '应收金额',
        width: '120',
        editRender: { // 开启该列可编辑
          name: 'input' // input/select/textarea
        }
      }],
      fundList0: [{
        type: 'selection',
        width: '40'
      }, {
        type: 'index',
        title: '序号',
        width: '60'
      }, {
        field: 'isAccounting',
        title: '记账',
        width: '60',
        editType: 'select',
        editRender: {
          name: 'select', // 编辑框为下拉框
          options: [
            {
              value: 1,
              label: '是'
            },
            {
              value: 0,
              className: 'color-46b8b0',
              label: '否'
            }
          ]
        }
      }, {
        field: 'specialItem',
        title: '代码',
        width: '80'
      }, {
        field: 'formulaCompute',
        title: '计算公式',
        width: '100'
      }, {
        field: 'itemName',
        title: '款项内容',
        width: '166'
      }, {
        field: 'planBill',
        title: '应收金额',
        width: '120'
      }, {
        field: 'realBill',
        title: '实收金额',
        width: '120'
      }],
      paymentDetail: [],
      tableFooter: [
        {
          columns: ['money'],
          type: 'sum',
          name: '合计'
        }
      ],
      tableFooter1: [
        {
          columns: ['planBill', 'realBill', 'undoBill'],
          type: 'sum',
          name: '合计'
        }
      ],
      tableFooter2: [
        {
          columns: ['planBill', 'realBill'],
          type: 'sum',
          name: '合计'
        }
      ],
      tableFooter3: [
        {
          columns: ['planBill', 'realBill', 'undoBill'],
          type: 'sum',
          name: '合计'
        }
      ],
      columnData: [{
        field: 'status',
        title: '单据状态',
        width: '80',
        editType: 'select',
        editRender: {
          name: 'select', // 编辑框为下拉框
          options: [
            {
              value: 2,
              label: '已记账'
            },
            {
              value: 1,
              className: 'color-46b8b0',
              label: '未记账'
            }
          ]
        },
        formatter: 'toJizhang'
      }, {
        field: 'accountTime',
        title: '记账日期',
        width: '180',
        editType: 'date',
        dateConfig: {
          format: 'yyyy-MM-dd HH:mm:ss',
          type: 'date',
          valueFormat: 'timestamp'
        },
        formatter: ['toDateString', 'yyyy-MM-dd HH:mm:ss']
      }, {
        field: 'number',
        title: '单据号',
        width: '200'
      }, {
        field: 'itemName',
        title: '款项内容',
        minWidth: '200'
      }, {
        field: 'money',
        title: '金额',
        width: '80'
      }, {
        field: 'account',
        title: '收款账户',
        width: '120'
      }, {
        field: 'accounterName',
        title: '收款人',
        width: '120'
      }, {
        field: 'createTime',
        title: '绘制日期',
        width: '180',
        editType: 'date',
        dateConfig: {
          format: 'yyyy-MM-dd',
          type: 'date',
          valueFormat: 'timestamp'
        },
        formatter: ['toDateString', 'yyyy-MM-dd']
      }, {
        field: 'writingNumber',
        title: '纸质单号',
        width: '200'
      }],
      tableArray: [],
      tableArray1: [
        {
          field: 'operate',
          title: '操作',
          width: '100',
          isDefine: true,
          child: [{
            type: 'btn',
            className: 'btn-16-color-46b8b0 btn-hover-46b8b0',
            title: '删除',
            methodName: 'on-delete1'
          }]
        }, {
          type: 'index',
          title: '序号',
          width: '60'
        }, {
          field: 'fundContent',
          title: '款项名称',
          width: '200'
        },
        {
          field: 'planBill',
          title: '应收',
          width: '100'
        },
        {
          field: 'realBill',
          title: '实收',
          width: '100'
        }, {
          field: 'undoBill',
          title: '未收',
          width: '100'
        }, {
          field: 'description',
          title: '说明',
          width: ''
        }
      ],
      tableData1: [],
      columnDetail: [{
        type: 'index',
        title: '序号',
        width: '60'
      }, {
        field: 'specialItem',
        title: '代码',
        width: '100'
      }, {
        field: 'fundContent',
        title: '款项内容',
        width: '200'
      }, {
        field: 'planBill',
        title: '应收金额',
        width: '100'
      }, {
        field: 'realBill',
        title: '实收金额',
        width: '100',
        editRender: {
          name: 'input'
        }
      }, {
        field: 'description',
        title: '说明',
        width: '',
        editRender: {
          name: 'input'
        }
      }],
      statistical: [{
        field: 'fundContent',
        title: '款项内容',
        width: '200'
      }, {
        field: 'planBill',
        title: '应收',
        width: '100'
      }, {
        field: 'realBill',
        title: '已收',
        width: '100'
      }, {
        field: 'undoBill',
        title: '未收',
        width: ''
      }],
      tableData: [{
        status: '1',
        number: 201922
      }, {
        status: '0',
        number: 201922
      }],
      paymentDialog: false,
      optionList: [],
      paymentTypeDialog: false,
      undoFunds: [],
      auditFunds: [],
      newFunds: [],
      fundType: null,
      array: [],
      noneShow: false,
      founddetail: {},
      statisticalData: []
    }
  },
  created () { },
  mounted () {
    this.id = this.$route.query.id
    this.parent = this.$route.query.parent
    this.getPermission()
    this.getInfo()
    this.getAccount()
  },
  methods: {
    selectAccount (way) {
      console.log(way)
      this.founddetail.account = ''
      this.founddetail.accountId = ''
      for (let i = 0; i < this.optionList.length; i++) {
        if (way === this.optionList[i].id) {
          this.founddetail.account = this.optionList[i].name
          this.founddetail.accountId = this.optionList[i].id
        }
        if (!this.founddetail.accountId && this.optionList[i].children) {
          for (let j = 0; j < this.optionList[i].children.length; j++) {
            if (way === this.optionList[i].children[j].id) {
              this.founddetail.account = this.optionList[i].children[j].name
              this.founddetail.accountId = this.optionList[i].children[j].id
            }
          }
        }
      }
      this.orderAccount()
    },
    orderAccount () {
      let params = {
        id: this.founddetail.id,
        account: this.founddetail.account,
        accountId: this.founddetail.accountId
      }
      this.axios.post('financeBill/modify', params).then(res => {
        if (res.data.success) {
          this.$message({
            message: `修改成功`,
            type: 'success'
          })
        }
      })
    },
    getInfo () {
      this.axios.post(`${this.$store.state.API_URL_9010}/customer/getById`, this.qs.stringify({
        id: this.id
      })).then(res => {
        if (res.data.success) {
          this.info = res.data.data
          this.customerAssign = res.data.data.customerAssign
          this.getTableData()
          this.getStatistical()
        }
      })
    },
    getAccount () {
      this.axios.post(`${this.$store.state.API_URL_9010}/account/list`, {
        companyId: this.$store.state.companyId
      }).then(res => {
        if (res.data.success) {
          let list = res.data.data
          list.forEach(item => {
            this.axios.post(`${this.$store.state.API_URL_9010}/account/list`, {
              companyId: this.$store.state.companyId,
              parentId: item.id
            }).then(res => {
              if (res.data.success) {
                if (res.data.data.length > 0) {
                  item.children = res.data.data
                }
              }
            })
          })
          this.optionList = list
        }
      })
    },
    getPermission () {
      let list = {}
      if (parseInt(this.type) === 1) {
        list.parent = 'projectPayment'
        list.parentGroup = 'projectPayment'
      } else if (parseInt(this.type) === 2) {
        list.parent = 'customerReceivables'
        list.parentGroup = 'customerReceivables'
      } else if (parseInt(this.type) === 3) {
        list.parent = 'commission'
        list.parentGroup = 'commission'
      }
      this.axios.post(`${this.$store.state.API_URL_9010}/permission/permissionStr`, list).then(res => {
        if (res.data.success) {
          this.permission = res.data.data.split(',')
        }
      })
    },
    getTableData () {
      let operate = {
        field: 'operate',
        title: '操作',
        width: '180',
        isDefine: true,
        child: [{
          className: 'btn-16-color-46b8b0 btn-hover-46b8b0 mr-5',
          title: '详情',
          methodName: 'on-detail',
          type: 'btn'
        }, {
          className: 'btn-16-color-46b8b0 btn-hover-46b8b0 mr-5',
          title: '退款',
          methodName: 'on-refund',
          type: 'btn',
          showStatus: 2
        }, {
          type: 'btn',
          className: 'btn-16-color-46b8b0 btn-hover-46b8b0 mr-5',
          title: '记账',
          methodName: 'on-account',
          showStatus: 1
        }, {
          type: 'btn',
          className: 'btn-16-color-46b8b0 btn-hover-46b8b0',
          title: '删除',
          methodName: 'on-delete',
          showStatus: 1
        }]
      }
      let operate1 = { // 基础操作
        field: 'operate',
        title: '操作',
        width: '140',
        isDefine: true,
        child: [{
          className: 'btn-16-color-46b8b0 btn-hover-46b8b0 mr-5',
          title: '详情',
          methodName: 'on-detail',
          type: 'btn'
        }, {
          type: 'btn',
          className: 'btn-16-color-46b8b0 btn-hover-46b8b0',
          title: '删除',
          methodName: 'on-delete',
          showStatus: 1
        }]
      }
      let operate2 = { // 记账
        field: 'operate',
        title: '操作',
        width: '80',
        isDefine: true,
        child: [{
          className: 'btn-16-color-46b8b0 btn-hover-46b8b0 mr-5',
          title: '退款',
          methodName: 'on-refund',
          type: 'btn',
          showStatus: 2
        }, {
          type: 'btn',
          className: 'btn-16-color-46b8b0 btn-hover-46b8b0 mr-5',
          title: '记账',
          methodName: 'on-account',
          showStatus: 1
        }]
      }
      this.axios.post(`${this.$store.state.API_URL_9010}/financeBill/queryForPage`, {
        page: this.page,
        limit: this.limit,
        customerId: this.info.id,
        type: this.type
      }).then(res => {
        if (res.data.success) {
          this.pageSize = res.data.data.pages
          this.pageNo = this.page
          this.pageTotal = res.data.data.size
          this.total = res.data.data.total
          let n = this.columnData.length
          console.log(7777777)
          if ((this.permission.includes('commissionBasic') || this.permission.includes('customerReceivablesBasic') || this.permission.includes('projectPaymentBasic')) && (this.permission.includes('commissionBooking') || this.permission.includes('customerReceivablesBooking') || this.permission.includes('projectPaymentBooking'))) {
            if (this.columnData[n - 1].field === 'operate') {
              this.columnData.splice(n - 1, 1, operate)
            } else {
              this.columnData.push(operate)
            }
          } else if (this.permission.includes('commissionBasic') || this.permission.includes('customerReceivablesBasic') || this.permission.includes('projectPaymentBasic')) {
            if (this.columnData[n - 1].field === 'operate') {
              this.columnData.splice(n - 1, 1, operate1)
            } else {
              this.columnData.push(operate1)
            }
          } else if (this.permission.includes('commissionBooking') || this.permission.includes('customerReceivablesBooking') || this.permission.includes('projectPaymentBooking')) {
            if (this.columnData[n - 1].field === 'operate') {
              this.columnData.splice(n - 1, 1, operate2)
            } else {
              this.columnData.push(operate2)
            }
          }
          console.log(this.type)
          if (this.type === 2) {
            if (this.columnData[n - 4].field === 'account') {
              this.columnData[n - 4].title = '收款账户'
            }
            if (this.columnData[n - 3].field === 'accounterName') {
              this.columnData[n - 3].title = '收款人'
            }
          }
          if (this.type === 1) {
            if (this.columnData[n - 4].field === 'account') {
              this.columnData[n - 4].title = '付款账户'
            }
            if (this.columnData[n - 3].field === 'accounterName') {
              this.columnData[n - 3].title = '付款人'
            }
          }
          if (this.type === 3) {
            if (this.columnData[n - 4].field === 'account') {
              this.columnData[n - 4].title = '提成账户'
            }
            if (this.columnData[n - 3].field === 'accounterName') {
              this.columnData[n - 3].title = '提成人'
            }
          }
          for (let i = 0; i < res.data.data.list.length; i++) {
            if (res.data.data.list[i].isRed === 1) {
              res.data.data.list[i].money = res.data.data.list[i].money * -1
            }
            // if (res.data.data.list[i].status === 1) {
            //   res.data.data.list[i].money = 0
            // }
          }
          this.paymentDetail = res.data.data.list
        }
      })
    },
    onSubmitBill () {
      this.$refs.addDetail.isPaymentShow = false
      this.getTableData()
    },
    jump (page) { // 分页
      this.page = page.pageNo
      this.limit = page.pageTotal
      this.getTableData()
    },
    // 统计
    getStatistical () {
      this.axios.post(`${this.$store.state.API_URL_9010}/financeBill/findStatistic`, {
        customerId: this.info.id,
        type: this.type
      }).then(res => {
        if (res.data.success) {
          this.statisticalData = res.data.data
        }
      })
    },
    switchTab (index) {
      this.tabIndex = index
      if (index === 2) {
        this.getStatistical()
      }
    },
    addPaymentOrder () {
      this.$refs.addDetail.isPaymentShow = true
    },
    // addPaymentOrder () {
    //   this.paymentDialog = true
    // },
    addPaymentType () {
      this.paymentTypeDialog = true
      this.axios.post(`${this.$store.state.API_URL_9010}/financeBill/findBillList`, {
        companyId: this.$store.state.companyId,
        customerId: 1,
        type: this.type
        // customerId: this.info.id
      }).then(res => {
        if (res.data.success) {
          this.auditFunds = res.data.data.auditFunds
          this.newFunds = res.data.data.newFunds
          this.undoFunds = res.data.data.undoFunds
          this.auditFunds.forEach(item => {
            if (item.billItemTemplateList && item.billItemTemplateList.length > 0) {
              for (var i = 0; i < item.billItemTemplateList.length; i++) {
                if (item.billItemTemplateList[i].isModified !== 1) {
                  item.billItemTemplateList[i].unEditable = 'planBill'
                }
              }
            }
            item.selected = false
          })
          this.newFunds.forEach(item => {
            if (item.billItemTemplateList && item.billItemTemplateList.length > 0) {
              for (var i = 0; i < item.billItemTemplateList.length; i++) {
                if (item.billItemTemplateList[i].isModified !== 1) {
                  item.billItemTemplateList[i].unEditable = 'planBill'
                }
              }
            }
            item.selected = false
          })
          this.undoFunds.forEach(item => {
            if (item.isModified !== 1) {
              item.unEditable = 'planBill'
            }
            item.selected = false
          })
        }
      })
    },
    onDetail (row) {
      this.detailDialog = true
      this.founddetail = row
      console.log(row)
      if (this.founddetail.financeBillItemList.length > 0) {
        for (var i = 0; i < this.founddetail.financeBillItemList.length; i++) {
          let str = ''
          if (this.founddetail.status === 2) {
            str = 'realBill'
          }
          this.founddetail.financeBillItemList[i].unEditable = str
        }
      }
    },
    onModify (row) {
      // let params = {
      //   id: this.founddetail.id,
      //   financeBillItemList: this.founddetail.financeBillItemList
      // }
      // this.axios.post('financeBill/modify', params).then(res => {
      //   if (res.data.success) {
      //     this.$message({
      //       message: `修改成功`,
      //       type: 'success'
      //     })
      //   }
      // })
    },
    toSave () {
      let financeBillItem = this.founddetail.financeBillItemList
      this.axios.post('financeBillItem/batchModify', financeBillItem).then(res => {
        if (res.data.success) {
          this.$message.success('保存成功')
          this.detailDialog = false
          // this.getfounddetail(this.smallRow)
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    orderNumber (e) { // 纸质单号
      let params = {
        id: this.founddetail.id,
        writingNumber: e
      }
      this.axios.post('financeBill/modify', params).then(res => {
        if (res.data.success) {
          this.$message({
            message: `修改成功`,
            type: 'success'
          })
        }
      })
    },
    orderMark (e) {
      let params = {
        id: this.founddetail.id,
        description: e
      }
      this.axios.post('financeBill/modify', params).then(res => {
        if (res.data.success) {
          this.$message({
            message: `修改成功`,
            type: 'success'
          })
        }
      })
    },
    openOrderTime (e) {
      let params = {
        id: this.founddetail.id,
        createTime: e
      }
      this.axios.post('financeBill/modify', params).then(res => {
        if (res.data.success) {
          this.$message({
            message: `修改成功`,
            type: 'success'
          })
        }
      })
    },
    onClose () {
      this.$router.go(-1)
    },
    onDelete (row) {
      if (row.status === 2) {
        this.$message({
          type: 'success',
          message: `${row.number}已经记账，不能删除`
        })
      } else {
        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.axios.post(`${this.$store.state.API_URL_9010}/financeBill/deleteById`, this.qs.stringify({
            id: row.id
          })).then(res => {
            if (res.data.success) {
              this.$message({
                type: 'success',
                message: '删除成功！'
              })
              this.getTableData()
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }
    },
    onRefund (row) {
      this.axios.post(`${this.$store.state.API_URL_9010}/financeBill/refund`, {
        id: row.id,
        companyId: this.$store.state.companyId
      }).then(res => {
        if (res.data.success) {
          this.$message({
            type: 'success',
            message: '退款成功！'
          })
          this.getTableData()
        }
      })
    },
    onAccount (row) {
      this.axios.post(`${this.$store.state.API_URL_9010}/financeBill/accounting`, {
        id: row.id
      }).then(res => {
        if (res.data.success) {
          this.$message({
            type: 'success',
            message: '记账成功！'
          })
          this.getTableData()
        }
      })
    },
    enter (index) {
      this.addIndex = index
    },
    leave () {
      this.addIndex = -1
    },
    enter1 (index) {
      this.addIndex1 = index
    },
    leave1 () {
      this.addIndex1 = -1
    }
  }
}
</script>

<style lang="scss" scoped>
.filtrate /deep/ .el-dialog__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.filtrate /deep/ .el-dialog {
  border-radius: 6px;
  margin: 0 !important;
  max-height: 100%;
  height: auto;
}

.filtrate /deep/ .el-dialog__header {
  display: none;
}

.filtrate /deep/ .el-dialog__body {
  padding: 0;
  display: flex;
  flex-direction: column;
}

.header {
  border-bottom: 1px solid #e2e2e2;
  padding: 14px;
  position: relative;
}

.close1 {
  color: #30313a;
  font-size: 22px;
  font-weight: bold;
  position: absolute;
  top: 10px;
  right: 10px;
  background: #ffffff;
}

.close {
  width: 50px;
  height: 50px;
  background: #ff5555;
}

.el-main {
  padding: 0;
}

.customerInfo {
  width: 100%;
  height: 50px;
  background: #fff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  font-size: 12px;
  color: #30313a;
  text-align: left;
  padding-left: 20px;
  position: relative;
}

.customerInfo span {
  color: #b9b9b9;
}

.line {
  height: 32px;
  background: #f3f4f7;
  width: 1px;
  margin: 0 20px;
}

.hr {
  width: 100%;
  height: 1px;
  background: #e2e2e2;
  margin: 10px 0;
}

.hr-dashed {
  width: 100%;
  height: 1px;
  border-bottom: 1px dashed #e2e2e2;
  margin: 12px 0;
}

.content {
  padding: 10px 20px;
}

.decoration-line {
  width: 4px;
  height: 16px;
  background-color: #46b8b0;
  border-radius: 4px;
}

.decoration-line-hui {
  width: 4px;
  height: 16px;
  background-color: #e2e2e2;
  border-radius: 4px;
}

.content .title {
  height: 30px;
  padding-left: 10px;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/pages/customer/components/payment.vue